import {
  DynamicWidget,
  DynamicConnectButton,
  useDynamicContext,
} from "@dynamic-labs/sdk-react-core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import Animated, { FadeInRight } from "react-native-reanimated";

interface Props {
  sendWalletAddress?: (address: string) => void;
}

export const GeneralWallet = (props: Props) => {
  const { primaryWallet } = useDynamicContext();

  const { t } = useTranslation();
  useEffect(() => {
    if (primaryWallet && primaryWallet?.address) {
      props.sendWalletAddress(primaryWallet.address);
    }
  }, [primaryWallet]);

  return (
    <Animated.View entering={FadeInRight.delay(100)}>
      {!primaryWallet ? (
        <DynamicConnectButton>
          <View className="bg-purple1 hover:bg-purple3 transition-colors delay-100 rounded-md items-center justify-center p-2 w-56 h-12">
            <Text className="text-base font-medium text-center text-white1">
              {t("common:button.connectwallet")}
            </Text>
          </View>
        </DynamicConnectButton>
      ) : (
        <DynamicWidget />
      )}
    </Animated.View>
  );
};
